import React from "react";

import AppView from "./app-view";

export default () => {
  return <AppView />;
};
